export const LIST_ACTIVITIES = 'LIST_ACTIVITIES';
export const LIST_ACTIVITIES_SUCCESS = 'LIST_ACTIVITIES_SUCCESS';
export const LIST_ACTIVITIES_FAILED = 'LIST_ACTIVITIES_FAILED';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const TOGGLE_STAFF_ACTIVITIES = 'TOGGLE_STAFF_ACTIVITIES';
export const FILTER_ACTIVITIES = 'FILTER_ACTIVITIES';
export const ENABLE_ACTIVITY_FILTER = 'ENABLE_ACTIVITY_FILTER';
export const DISABLE_ACTIVITY_FILTER = 'DISABLE_ACTIVITY_FILTER';
export const SUPERSEDE_ACTIVITY = 'SUPERSEDE_ACTIVITY';
